import React from 'react';

import {observer} from 'mobx-react';
import {RateOptionViewModel} from "../../../../domain/common/odds/rate-option/models/rate-option.view-model";
import {GameCardOddsCell} from "./game-card-odds-cell/game-card.odds-cell";
import styles from "./game-card-odds.module.scss";
import classnames from "classnames";
import {GAME_STATUSES} from "../../../app/consts";
export const GameCardOddsCells = observer(({
                                        game,
                                        source,
                                        controller,
                                        cellClassName,
                                        disableTooltip,
                                        betsImpressionParams,
                                        highlightOdds
                                      }) => {
  const {odds} = game;

  const gameCardOddsCellProps = {
    game,
    source,
    controller,
    betsImpressionParams,
    cellClassName: classnames(cellClassName, styles.cell),
    showOriginalOdds: game.statusGroup !== GAME_STATUSES.ended,
    disableTooltip,
    highlightOdds
  }

  return odds.rateOptions.map((option: RateOptionViewModel) => <GameCardOddsCell key={option.num} option={option} {...gameCardOddsCellProps}/>)

});
